module.exports = __webpack_public_path__ + "static/media/pl-PL.047f06ac.md";